import React from 'react';

interface PrintLabelBodyProduct {
  title: string;
  quantity: number;
}

interface PrintLabelBodyProps {
  products: PrintLabelBodyProduct[];
}

export function PrintLabelBody({ products }: PrintLabelBodyProps) {
  return (
    <>
      {products.map((product, index) => (
        <React.Fragment key={index}>
          <p style={{ fontSize: '16px', lineHeight: '17px', margin: '10px 0' }}>
            <span style={{ fontSize: '30px', lineHeight: '33px' }}>{'\u25A1'} </span>
            {product.title}
            {product.quantity > 1 && (
              <b style={{ fontSize: '30px', lineHeight: '33px' }}>{` x${product.quantity}`}</b>
            )}
          </p>
          <hr
            style={{
              border: 'none',
              backgroundColor: 'black',
              height: '1px',
              width: '20%',
              margin: '0 auto 10px auto',
            }}
          />
        </React.Fragment>
      ))}
    </>
  );
}
